import services from "../services";
import {billerCrossReferenceService} from "../services/billerCrossReference.service";

export const billerCrossReferenceActions = {
    searchBillerCrossReference,
    searchLinkedInstitutionsForProfileLinking,
    authenticateLinkedBiller,
};

function searchBillerCrossReference(values, props) {
    return services.billerCrossReferenceService.searchBillerCrossReference(values, props);
}

function searchLinkedInstitutionsForProfileLinking(values, props) {
    return services.billerCrossReferenceService.searchLinkedInstitutionsForProfileLinking(values, props);
}

function authenticateLinkedBiller(values, props) {
    return services.billerCrossReferenceService.authenticateLinkedBiller(values, props);
}


